/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ArrowRightIcon } from 'modules/icons/ArrowRight';

import * as S from './Popup.style';
import * as T from './Popup.types';

export const Popup: React.FC<T.PopupCollection> = ({ appSelected, handleSetCategorySelected }) => {
  return (
    <>
      <S.Popup>
        <div className="top">
          <img src={appSelected.appLogo.url} alt={appSelected.appName} width={100} height={100} />
          <div className="shortDescription">
            <h3>{appSelected.appName}</h3>
            <p>{appSelected.shortDescription}</p>
            <a href={appSelected.url} target="_blank" rel="noreferrer">
              {appSelected.url}
            </a>
          </div>
        </div>
        <div className="content">
          <div className="text">{documentToReactComponents(appSelected.description?.json)}</div>
          {appSelected.imagesCollection.items && (
            <div>
              <Swiper spaceBetween={0} slidesPerView={1} navigation pagination={false}>
                {appSelected.imagesCollection.items.map((item) => {
                  return (
                    <SwiperSlide key={appSelected.appName}>
                      <img src={item.url} alt={appSelected.appName} width={500} height={300} />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          )}
        </div>
        <div className="bottom">
          <div className="left">
            <span>Categorias</span>
            <div>
              <strong onClick={() => handleSetCategorySelected(appSelected.category)}>
                {appSelected.category}
              </strong>
            </div>
          </div>
          <div className="right">
            {appSelected.callToAction &&
              // eslint-disable-next-line array-callback-return, consistent-return
              appSelected.callToAction.data
                .filter(
                  (item: { url?: string; title?: string }) => !item.url?.includes('/admin/config')
                )
                .map((item: { url?: string; title?: string }) => {
                  return (
                    <S.Link href={item.url} key={item.title}>
                      {item.title}
                      <ArrowRightIcon />
                    </S.Link>
                  );
                })}
          </div>
        </div>
      </S.Popup>
    </>
  );
};
